import { type FC, type ReactNode } from 'react'
import classNames from 'classnames'

interface FieldLabelProps {
  htmlFor?: string
  className?: string
  children: ReactNode
}

export const FieldLabel: FC<FieldLabelProps> = ({ htmlFor, className, children }) => (
  <label htmlFor={htmlFor} className={classNames('paragraph-small bold', className)}>
    {children}
  </label>
)
